import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as connectedReactRouter from 'connected-react-router'
import * as reducks from '../../../reducks'
import routes from '../../../config/routes'
import Text from '../../commons/Text/Text'
import ExternalLayout from '../../commons/Layouts/ExternalLayout'
import Button from '../../commons/Button/Button'
import FlameSantander from '../../commons/Icons/FlameSantander'
import Link from '../../commons/Link/Link'
import styles from './recoveryPasswordSentEmailFeedbackContainer.module.scss'

export const checkEmailOrRedirect = (email, dispatch) => {
  if (email) return true

  return dispatch(
    connectedReactRouter.routerActions.push(routes.resetPasswordSentEmail.path)
  )
}

const RecoveryPasswordEmailLinkSentContainer = () => {
  const dispatch = useDispatch()
  const email = useSelector(
    (state) => state.usersReducer.content.resetPassword.email
  )
  const handleResent = () =>
    dispatch(reducks.resources.users.actions.resetPasswordResentEmail())

  useEffect(() => {
    checkEmailOrRedirect(email, dispatch)
  }, [])

  return (
    <ExternalLayout>
      <div className={styles.container}>
        <FlameSantander />
        <Text
          color="gray"
          variation="dark"
          size="lg"
          bold
          inline
          margin="10px 0px"
        >
          Redefinição de senha.
        </Text>
        <Text color="gray" variation="dark" size="md" margin="10px 0px">
          Um e-mail com um link de confirmação foi enviado para {email}
        </Text>
        <Text color="gray" variation="dark" size="md">
          Não recebeu o e-mail de confirmação?
        </Text>
      </div>
      <div className={styles.containerButton}>
        <Link to={routes.login.path}>
          <Button
            type="outlined_dark"
            margin="12px 10px 0px"
            buttonType="button"
            width="160px"
          >
            <Text
              font="custom"
              color="gray"
              variation="dark"
              size="xs"
              value="Login"
              bold
            />
          </Button>
        </Link>
        <Button
          type="secondary"
          margin="12px 0 0"
          buttonType="button"
          width="160px"
          onClick={handleResent}
        >
          <Text font="custom" color="white" size="xs" value="Reenviar" bold />
        </Button>
      </div>
    </ExternalLayout>
  )
}

export default RecoveryPasswordEmailLinkSentContainer
